import { Component, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateService } from '@ngx-translate/core';
import { MemberService } from '@fgb/core';

import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@ngx-translate/core';
import * as ɵngcc2 from '@fgb/core';
import * as ɵngcc3 from '@angular/common';

const _c0 = function (a0, a1) { return { "bg-secondary text-white": a0, "bg-white": a1 }; };
class LanguageSelectorComponent {
    constructor(translate, memberService) {
        this.translate = translate;
        this.memberService = memberService;
        this.currentLcid = '';
    }
    ngOnInit() {
        this.currentLcid = localStorage.getItem('lcid');
        this.updateActiveLanguage(this.currentLcid);
    }
    useLanguage(lcid) {
        this.memberService.setLcid(lcid);
        setTimeout(() => {
            location.reload();
        }, 1000);
    }
    // update active language button
    updateActiveLanguage(lcid) {
        if (this.currentLcid === '2057') {
            this.currentLanguage = 'en';
            this.translate.use('en-GB');
        }
        else if (this.currentLcid === '3084') {
            this.currentLanguage = 'fr';
            this.translate.use('fr-FR');
        }
        else if (this.currentLcid === '1037') {
            this.currentLanguage = 'he';
            this.translate.use('he');
        }
        else if (this.currentLcid === '1033') {
            this.currentLanguage = 'us';
            this.translate.use('en-US');
        }
    }
}
LanguageSelectorComponent.ɵfac = function LanguageSelectorComponent_Factory(t) { return new (t || LanguageSelectorComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc1.TranslateService), ɵngcc0.ɵɵdirectiveInject(ɵngcc2.MemberService)); };
LanguageSelectorComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: LanguageSelectorComponent, selectors: [["fgbcl-language-selector"]], decls: 14, vars: 16, consts: [[1, "row", "mx-0"], [1, "col-6", "pr-1", "text-right"], ["id", "en-btn", 1, "btn", "shadow", "btn-change-locale", "py-0", 3, "ngClass", "click"], [1, "col-6", "pl-1", "text-left"], ["id", "fr-btn", 1, "btn", "shadow", "btn-change-locale", "py-0", 3, "ngClass", "click"], ["id", "he-btn", 1, "btn", "shadow", "btn-change-locale", "py-0", 3, "ngClass", "click"], ["id", "us-btn", 1, "btn", "shadow", "btn-change-locale", "py-0", 3, "ngClass", "click"]], template: function LanguageSelectorComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵelementStart(2, "button", 2);
        ɵngcc0.ɵɵlistener("click", function LanguageSelectorComponent_Template_button_click_2_listener() { return ctx.useLanguage(2057); });
        ɵngcc0.ɵɵtext(3, " EN ");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(4, "div", 3);
        ɵngcc0.ɵɵelementStart(5, "button", 4);
        ɵngcc0.ɵɵlistener("click", function LanguageSelectorComponent_Template_button_click_5_listener() { return ctx.useLanguage(3084); });
        ɵngcc0.ɵɵtext(6, " FR ");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(7, "div", 0);
        ɵngcc0.ɵɵelementStart(8, "div", 1);
        ɵngcc0.ɵɵelementStart(9, "button", 5);
        ɵngcc0.ɵɵlistener("click", function LanguageSelectorComponent_Template_button_click_9_listener() { return ctx.useLanguage(1037); });
        ɵngcc0.ɵɵtext(10, " HE ");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(11, "div", 3);
        ɵngcc0.ɵɵelementStart(12, "button", 6);
        ɵngcc0.ɵɵlistener("click", function LanguageSelectorComponent_Template_button_click_12_listener() { return ctx.useLanguage(1033); });
        ɵngcc0.ɵɵtext(13, " US ");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction2(4, _c0, ctx.currentLanguage === "en", ctx.currentLanguage !== "en"));
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction2(7, _c0, ctx.currentLanguage === "fr", ctx.currentLanguage !== "fr"));
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction2(10, _c0, ctx.currentLanguage === "he", ctx.currentLanguage !== "he"));
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction2(13, _c0, ctx.currentLanguage === "us", ctx.currentLanguage !== "us"));
    } }, directives: [ɵngcc3.NgClass], styles: [""] });
LanguageSelectorComponent.ctorParameters = () => [
    { type: TranslateService },
    { type: MemberService }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(LanguageSelectorComponent, [{
        type: Component,
        args: [{
                selector: 'fgbcl-language-selector',
                template: "<div class=\"row mx-0\">\r\n  <div class=\"col-6 pr-1 text-right\">\r\n    <button\r\n      (click)=\"useLanguage(2057)\"\r\n      class=\"btn shadow btn-change-locale py-0\"\r\n      [ngClass]=\"{ 'bg-secondary text-white': currentLanguage === 'en', 'bg-white': currentLanguage !== 'en' }\"\r\n      id=\"en-btn\"\r\n    >\r\n      EN\r\n    </button>\r\n  </div>\r\n  <div class=\"col-6 pl-1 text-left\">\r\n    <button\r\n      (click)=\"useLanguage(3084)\"\r\n      class=\"btn shadow btn-change-locale py-0\"\r\n      [ngClass]=\"{ 'bg-secondary text-white': currentLanguage === 'fr', 'bg-white': currentLanguage !== 'fr' }\"\r\n      id=\"fr-btn\"\r\n    >\r\n      FR\r\n    </button>\r\n  </div>\r\n</div>\r\n\r\n<div class=\"row mx-0\">\r\n  <div class=\"col-6 pr-1 text-right\">\r\n    <button\r\n      (click)=\"useLanguage(1037)\"\r\n      class=\"btn shadow btn-change-locale py-0\"\r\n      [ngClass]=\"{ 'bg-secondary text-white': currentLanguage === 'he', 'bg-white': currentLanguage !== 'he' }\"\r\n      id=\"he-btn\"\r\n    >\r\n      HE\r\n    </button>\r\n  </div>\r\n  <div class=\"col-6 pl-1 text-left\">\r\n    <button\r\n      (click)=\"useLanguage(1033)\"\r\n      class=\"btn shadow btn-change-locale py-0\"\r\n      [ngClass]=\"{ 'bg-secondary text-white': currentLanguage === 'us', 'bg-white': currentLanguage !== 'us' }\"\r\n      id=\"us-btn\"\r\n    >\r\n      US\r\n    </button>\r\n  </div>\r\n</div>\r\n",
                styles: [""]
            }]
    }], function () { return [{ type: ɵngcc1.TranslateService }, { type: ɵngcc2.MemberService }]; }, null); })();

class LanguageSelectorModule {
}
LanguageSelectorModule.ɵfac = function LanguageSelectorModule_Factory(t) { return new (t || LanguageSelectorModule)(); };
LanguageSelectorModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: LanguageSelectorModule });
LanguageSelectorModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ imports: [[CommonModule]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(LanguageSelectorModule, { declarations: function () { return [LanguageSelectorComponent]; }, imports: function () { return [CommonModule]; }, exports: function () { return [LanguageSelectorComponent]; } }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(LanguageSelectorModule, [{
        type: NgModule,
        args: [{
                declarations: [LanguageSelectorComponent],
                imports: [CommonModule],
                exports: [LanguageSelectorComponent]
            }]
    }], null, null); })();

/**
 * Generated bundle index. Do not edit.
 */

export { LanguageSelectorComponent, LanguageSelectorModule };

//# sourceMappingURL=fgb-portal-component-library-src-lib-shared-language-selector.js.map